<template>
  <div>
    <kn-form-subtitle :title="`${actionTitle} estatus de egreso`" />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col 
          class="pb-0" 
          cols="12"
          md="4"
          lg="4"
          xl="4"
        >
          <v-subheader>Título:</v-subheader>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="expenseStatus.dato"
            dense
            outlined
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>
      <kn-form-action-buttons
        class="mb-14"
        :small="true"
        :disableAccept="invalidFields"
        @accept="save"
        @cancel="clear"
      />
    </v-form>
    <kn-form-subtitle
      title="Listado de estatus de egreso"
      divider-position="bottom"
    />
    <kn-list-with-actions
      :activeItems="activeExpenseStatus"
      @updateInline="updateInline"
      @deleteInline="deleteInline"
      @cancelInline="clearInline"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api/axios-base'
import { validationFormMixin } from '@/mixins/validationFormMixin'
export default {
  components: {
    KnFormSubtitle: () => import('@/components/KnFormSubtitle.vue'), 
    KnFormActionButtons: () => import('@/components/KnFormActionButtons.vue'),
    KnListWithActions: () => import('./KnListWithActions.vue')
  },
  mixins: [validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      expenseStatus: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null
      },
      status: [],
      toUpdate: false
    }
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Agregar'
    },
    activeExpenseStatus() {
      return this.status.filter(st => st.estatus_sistema === true)
    },
    invalidFields() {
      return this.objectHasNulls(this.expenseStatus)
    }
  },
  async created() {
    this.expenseStatus.id_autor = this.userData.id
    this.expenseStatus.id_institucion_educativa = this.institutionId
    this.status = await this.fetchExpenseStatusByEI(this.institutionId)

  },
  methods: {
    async fetchExpenseStatusByEI(institutionId) {
      try {
        const response = await api.get(`/administracion/api/estatus-egreso-by-ie/?id_institucion=${institutionId}`)
        const responseData = await response.data
        return responseData
      } catch (error) {
        console.error('Error al intentar obtener estatus de egreso por institucion educativa', error);
      }
    },
    async createExpenseStatus() {
      try {
        const response = await api.post('/administracion/crear-estatus-egreso', {
          esstatus_egreso: this.expenseStatus.dato,
          id_autor: this.expenseStatus.id_autor,
          id_institucion_educativa: this.expenseStatus.id_institucion_educativa
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo crear el estatus de egreso.')
        }
      } catch (error) {
        console.error('Error al intentar crear estatus de egreso', error)
        this.errors.push('Error al intentar crear estatus de egreso')
      }
    },
    async updateExpenseStatus() {
      try {
        const response = await api.patch('/administracion/update-estatus-egreso', {
          id: this.expenseStatus.id,
          estatus_egreso: this.expenseStatus.dato,
          id_institucion_educativa: this.institutionId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo actualizar el estatus de egreso')
        }
      } catch (error) {
        console.error('Error al intentar actualizar estatus de egreso', error);
      }
    },
    // Los deletes no eliminan los registros, cambian el estatus a False
    async deleteExpenseStatus(typeId) {
      try {
        const response = await api.post('/administracion/delete-estatus-egreso', {
          id_estatus_egreso: typeId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo eliminar el estatus de egreso')
        }
      } catch (error) {
        console.error('Error al intentar eliminar estatus de egreso', error);
      }
    },
    async save() {
      await this.createExpenseStatus()
      this.status = await this.fetchExpenseStatusByEI(this.institutionId)
      this.clear()
    },
    clear() {
      this.expenseStatus = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    clearInline() {
      this.expenseStatus = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    async updateInline(item) {
      // console.log('updateInline item', item);
      this.expenseStatus = {...item}
      await this.updateExpenseStatus()
      this.status = await this.fetchExpenseStatusByEI(this.institutionId)
      this.clearInline()
    },
    async deleteInline(itemId) {
      await this.deleteExpenseStatus(itemId)
      this.status = await this.fetchExpenseStatusByEI(this.institutionId)
      this.clearInline()
    }
  },
}
</script>

<style>

</style>